import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DashboardCard from "../../../../pages/home/common/DashboardCard";
import ReactVortoxSpinner from "../../../common-components/ReactVortoxSpinner";

const LateCheckinStats = () => {
  const {
    lateCheckinsStatsData,
    lateCheckinsStatsDataLoading,
    lateCheckinsStatsDataError,
  } = useSelector((state) => state.api);

  const [calStats, setCalStats] = useState({});

  useEffect(() => {
    if (
      !lateCheckinsStatsDataLoading &&
      !lateCheckinsStatsDataError &&
      lateCheckinsStatsData?.status &&
      lateCheckinsStatsData?.data
    ) {
      setCalStats(lateCheckinsStatsData.data);
    } else {
      setCalStats({});
    }
  }, [
    lateCheckinsStatsData,
    lateCheckinsStatsDataError,
    lateCheckinsStatsDataLoading,
  ]);

  return (
    <div className="cards-container cards-grid-container lead-cards grid-4">
      {lateCheckinsStatsDataLoading ? (
        <ReactVortoxSpinner />
      ) : (
        Object.entries(calStats).map(([key, value]) => (
          <DashboardCard
            key={key}
            tagName={key}
            cardLabel={
              key === "total_late_day"
                ? "Total Late Checkins Day"
                : key.replace(/_/g, " ")
            }
            value={value || 0}
          />
        ))
      )}
    </div>
  );
};

export default LateCheckinStats;
